import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';

const PARTICLES = [
  { id: 'p0', emoji: '⚽', angle: 0, dist: 110 },
  { id: 'p1', emoji: '⭐', angle: 45, dist: 130 },
  { id: 'p2', emoji: '🎉', angle: 90, dist: 115 },
  { id: 'p3', emoji: '⭐', angle: 135, dist: 125 },
  { id: 'p4', emoji: '⚽', angle: 180, dist: 110 },
  { id: 'p5', emoji: '🎉', angle: 225, dist: 130 },
  { id: 'p6', emoji: '⭐', angle: 270, dist: 120 },
  { id: 'p7', emoji: '⚽', angle: 315, dist: 115 },
];

const toXY = (angle, dist) => ({
  x: Math.cos((angle * Math.PI) / 180) * dist,
  y: Math.sin((angle * Math.PI) / 180) * dist,
});

const ShiftCreatedOverlay = ({ visible, onDone, teamLocal, teamVisit, icon = '⚽', title = '¡Partido Creado!', subtitle }) => {
  useEffect(() => {
    if (!visible) return undefined;
    const t = setTimeout(onDone, 2600);
    return () => clearTimeout(t);
  }, [visible, onDone]);

  return ReactDOM.createPortal(
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 2000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.82)',
            backdropFilter: 'blur(6px)',
          }}
          onClick={onDone}
        >
          {/* Particles */}
          {PARTICLES.map((p, i) => {
            const { x, y } = toXY(p.angle, p.dist);
            return (
              <motion.span
                key={p.id}
                initial={{ opacity: 0, x: 0, y: 0, scale: 0 }}
                animate={{ opacity: [0, 1, 1, 0], x, y, scale: [0, 1.2, 1, 0.8] }}
                transition={{ duration: 1.1, delay: 0.3 + i * 0.04, ease: 'easeOut' }}
                style={{
                  position: 'absolute',
                  fontSize: '22px',
                  pointerEvents: 'none',
                }}
              >
                {p.emoji}
              </motion.span>
            );
          })}

          {/* Main icon */}
          <motion.div
            initial={{ scale: 0, rotate: -30 }}
            animate={{ scale: [0, 1.3, 0.9, 1.05, 1], rotate: [0, 15, -10, 5, 0] }}
            transition={{ duration: 0.7, ease: 'easeOut' }}
            style={{ fontSize: '80px', lineHeight: 1, marginBottom: '16px' }}
          >
            {icon}
          </motion.div>

          {/* Title */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.45, duration: 0.4, ease: [0.215, 0.61, 0.355, 1] }}
            style={{
              color: '#ffffff',
              fontSize: '26px',
              fontWeight: 700,
              letterSpacing: '-0.5px',
              textAlign: 'center',
            }}
          >
            {title}
          </motion.div>

          {/* Subtitle: teams or custom */}
          {(subtitle || (teamLocal && teamVisit)) && (
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.35, ease: [0.215, 0.61, 0.355, 1] }}
              style={{
                color: 'rgba(255,255,255,0.65)',
                fontSize: '15px',
                marginTop: '6px',
                textAlign: 'center',
              }}
            >
              {subtitle || `${teamLocal} vs ${teamVisit}`}
            </motion.div>
          )}

          {/* Tap to dismiss hint */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 0.4 }}
            style={{
              color: 'rgba(255,255,255,0.3)',
              fontSize: '12px',
              marginTop: '32px',
            }}
          >
            Toca para continuar
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body,
  );
};

export default ShiftCreatedOverlay;
